<template>
  <Bar
    :id="chartId"
    :options="chartOptions"
    :data="chartData"
  />
</template>

<script>
import * as formatUtils from '../../composables/formatUtils'
import { Bar } from 'vue-chartjs'
import { Chart as ChartJS, Tooltip, BarElement, LineElement, PointElement, LineController, CategoryScale, LinearScale, Legend } from 'chart.js'

ChartJS.register(BarElement, Tooltip, PointElement, CategoryScale, LinearScale, Legend)
ChartJS.register(LineController, LineElement)

export default {
  name: 'KPIPeriodMultiChart',
  components: { Bar },
  props: ['chartId', 'periods'],
  data () {
    return {
      chartData: {
        labels: this.periods.map(period => this.formatPeriod(period.period)),
        datasets: [
          {
            label: this.$t('views.kpi.edit.actual'),
            data: this.periods.map(period => this.unFormatNumber(period.actual)),
            backgroundColor: '#6c80bb',
            barPercentage: 0.6,
            maxBarThickness: 50,
            order: 1
          },
          {
            label: this.$t('views.kpi.edit.forecast'),
            data: this.periods.map(period => this.unFormatNumber(period.forecast)),
            backgroundColor: '#6c80bb73',
            barPercentage: 0.6,
            maxBarThickness: 50,
            order: 2
          },
          {
            label: this.$t('views.kpi.edit.plan'),
            data: this.periods.map(period => this.unFormatNumber(period.plan)),
            backgroundColor: '#bfbfbf',
            barPercentage: 0.6,
            maxBarThickness: 50,
            order: 3
          },
          {
            label: this.$t('views.kpi.edit.objective'),
            data: this.periods.map(period => this.unFormatNumber(period.objective) ? this.unFormatNumber(period.objective) : null),
            backgroundColor: '#dc3545',
            barPercentage: 0.6,
            maxBarThickness: 50,
            order: 4,
            pointRadius: 3,
            type: 'line',
            borderColor: '#dc3545'
          }
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        animation: false,
        plugins: { legend: { position: 'top', labels: { boxWidth: 20, boxHeight: 8, padding: 12 } } }
      }
    }
  },
  methods: {
    formatPeriod (period) {
      return formatUtils.formatPeriod(period)
    },
    unFormatNumber (number) {
      const userLocale = this.$store.state.user.settings?.language
      return formatUtils.unFormatNumber(userLocale, number)
    }
  }
}
</script>
